var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-header"},[_c('img',{attrs:{"src":this.$projectPath + '/image/robot.png'}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"title"},[_c('span',{staticClass:"bigger"}),_vm._v("行政审批智能助手(试运行) ")])
}]

export { render, staticRenderFns }